/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = FirstVideo
 *
 * 2 = SecondVideo
 *
 * 3 = ThirdVideo
 */
export enum VideoNumberEnum {
  FirstVideo = 1,
  SecondVideo = 2,
  ThirdVideo = 3,
}
